<template>
    <div>
        <ViewPaymentType  v-if="!!item" @success="alertSuccess"></ViewPaymentType>

        <PaymentTypeTable
            title="Users"
            @addHealth="showPaymentTypeModal"
            ref="table"
        ></PaymentTypeTable>
        
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import PaymentTypeTable from './PaymentTypeTable'
import ViewPaymentType from './ViewPaymentType'
// import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'payment-type',
    mixins: [popupMixins, permissionsMixins],
    components: {
        PaymentTypeTable,
        ViewPaymentType,
    },
    data: () => {
        return {
            item: null,
        }
    },

    methods: {
        alertSuccess(action) {
            console.log("asdasda",action)
            console.log(this.item)
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
            //this.doToast('Success', `Item ${action}!`, 'success')
            this.item = null
            this.$refs.table.doSearch()
        },
        showPaymentTypeModal() {
            this.$refs.createDocumentType.showModal()
        },
        // created() {
        //     this.doToast('Created!', 'Vehicle Created', 'success')
        //     this.$refs.table.doSearch()
        //     this.$refs.createVehicle.hideModal()
        // },
        handleError(error) {
            this.doToast(this.$translate('error'), error.message, 'danger')
        },
    },
}
</script>
<style></style>
